export const exchangeQuoteTemplate = `<div>
  <div>
    {{#if (eq exchangeQuote.fixedSide 'buy')}}
    <div><label>Selling</label></div>
    {{else}}
    <div><label>Selling (includes fees)</label></div>
    {{/if}}
    {{#if (eq exchangeQuote.fixedSide 'buy')}}
    <div class="d-flex is-space-between">
      <div>
        <h2>
         {{{ currencyPipe exchangeQuote.feeAmountPlusSellAmount currencyCode=exchangeQuote.sellCurrency  display="symbol-narrow" }}}
        </h2>
      </div>
      <div>
        {{{ currencyToFlag exchangeQuote.sellCurrency '40px' }}}
      </div>
    </div>
    <div>
      <span
        >({{{  currencyPipe exchangeQuote.sellAmount currencyCode=exchangeQuote.sellCurrency  display="symbol-narrow"}}}
        +
        {{{  currencyPipe exchangeQuote.feeAmount currencyCode=exchangeQuote.sellCurrency display="symbol-narrow" }}})</span
      >
    </div>
    {{else}}
    <div class="d-flex is-space-between">
      <div>
        <h2>
          {{{ currencyPipe exchangeQuote.sellAmount currencyCode=exchangeQuote.sellCurrency  display="symbol-narrow" }}}
        </h2>
      </div>
      <div>
        {{{ currencyToFlag exchangeQuote.sellCurrency '40px' }}}
      </div>
    </div>
    {{/if}}
  </div>
  <hr />
  <div class="mt-3">
    <div>
      {{#if (eq exchangeQuote.fixedSide 'buy')}}
      <div><label>Buying</label></div>
      {{else}}
      <div><label>Buying (includes fees)</label></div>
      {{/if}}
      {{#if (eq exchangeQuote.fixedSide 'sell')}}
      <div class="d-flex is-space-between">
        <div>
          <h2>
            {{{ currencyPipe exchangeQuote.buyAmountMinusFeeAmount currencyCode=exchangeQuote.buyCurrency display="symbol-narrow" }}}
          </h2>
        </div>
        <div>
          {{{ currencyToFlag exchangeQuote.buyCurrency '40px' }}}
        </div>
      </div>
      <div>
        <span
          >({{{ currencyPipe exchangeQuote.buyAmount currencyCode=exchangeQuote.buyCurrency display="symbol-narrow" }}}
          -
          {{{ currencyPipe exchangeQuote.feeAmount currencyCode=exchangeQuote.buyCurrency display="symbol-narrow" }}})</span
        >
      </div>
      {{else}}
      <div class="d-flex is-space-between">
        <div>
          <h2>
            {{{ currencyPipe exchangeQuote.buyAmount currencyCode=exchangeQuote.buyCurrency display="symbol-narrow" }}}
          </h2>
        </div>
        <div>
          {{{ currencyToFlag exchangeQuote.buyCurrency '40px' }}}
        </div>
      </div>
      {{/if}}
    </div>
  </div>
  <hr />
  <div class="mt-3">
    <div class="mb-2">
     <div><small>Exchange Rate</small></div>
      <div>
        <span>{{{ currencyPipe 1 currencyCode=exchangeQuote.sellCurrency  display="symbol-narrow"}}} =
          {{{ currencyPipe exchangeQuote.exchangeRate currencyCode=exchangeQuote.buyCurrency  display="symbol-narrow" }}}
        </span>
      </div>
    </div>
    <div class="d-flex">
      <div class="mb-2 mr-3 ml-0 col-6">
        <div>
          <small>{{{ exchangeQuote.companyName }}} Fees</small>
        </div>
        <div>
          <span>{{{ currencyPipe exchangeQuote.feeAmount currencyCode=exchangeQuote.feeCurrency display="symbol-narrow" }}}</span>
        </div>
      </div>
    </div>
    <hr />
    <div class="d-flex">
      <div class="mr-3 ml-0 col-6-xs">
        <div><small>Settlement Date</small></div>
        <div>
          <span>{{{ datePipe exchangeQuote.settlementDate format='dd MMM YYYY' }}}</span>
        </div>
      </div>
      <div>
        <div><small>Conversion Date</small></div>
        <div>
          <span>{{{ datePipe exchangeQuote.exchangeDate format='dd MMM YYYY' }}}</span>
        </div>
      </div>
    </div>
  </div>`;
